// 开启 HMR 支持
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App.jsx';
import { getURLParam } from './utils/index';

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  /* 打开H5 */
  // window.location.href = getURLParam('debug') ? 'http://testhd.huya.com/h5/YSH5/12/index.html?anchorUid=1199518915448' : 'https://hd.huya.com/h5/YSH5/12/index.html?anchorUid=1199518915448';
} else {
  if (getURLParam('type') === '1' || getURLParam('type') === '2') {
    ReactDOM.render(<App />, document.getElementById('root'));
  }
}
